import { useEffect, useState, useRef } from "react";
import styles from "./company.module.css";
import CustomModal from "../MODAL";

const Companies = ({
  size,
  index,
  totalCompanies,
  title,
  imageUrl,
  description,
  siteUrl,
  logo,
  logoRef,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [imagePosition, setImagePosition] = useState({});
  const [radius, setRadius] = useState(500);
  const [centerX, setCenterX] = useState(50);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1024); // Changed to 1024px
  const companyRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1024); // Changed to 1024px
      if (window.innerWidth > 1024) {
        const newRadius = window.innerHeight * 0.6;
        setRadius(newRadius);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isSmallScreen) {
      const handleResizeCenterX = () => {
        if (logoRef && logoRef.current) {
          const logoRect = logoRef.current.getBoundingClientRect();
          const logoCenterX = logoRect.left + logoRect.width / 2;
          setCenterX((logoCenterX / window.innerWidth) * 100);
        }
      };

      handleResizeCenterX();
      window.addEventListener("resize", handleResizeCenterX);
      return () => window.removeEventListener("resize", handleResizeCenterX);
    }
  }, [logoRef, isSmallScreen]);

  useEffect(() => {
    if (isSmallScreen && companyRef.current) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.3 }
      );

      observer.observe(companyRef.current);
      return () => observer.disconnect();
    } else if (!isSmallScreen) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 10);
      return () => clearTimeout(timer);
    }
  }, [isSmallScreen]);

  const openModal = (e) => {
    setImagePosition(e.target.getBoundingClientRect());
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (!isModalOpen) {
      setImagePosition({});
    }
  }, [isModalOpen]);

  const angle = (index / (totalCompanies - 1)) * Math.PI;
  const centerY = 10;

  const companyStyles = isSmallScreen
    ? {
        width: size,
        height: size,
        backgroundImage: `url(${imageUrl})`,
        opacity: isVisible ? 1 : 0,
        transition: "opacity 1s ease-out",
      }
    : {
        width: size,
        height: size,
        backgroundImage: `url(${imageUrl})`,
        top: isVisible
          ? `calc(${centerY}% + ${radius * Math.sin(angle)}px)`
          : `calc(50% - ${radius}px)`,
        left: isVisible
          ? `calc(${centerX}% + ${radius * Math.cos(angle) - 50}px)`
          : "50%",
      };

  return (
    <div className={styles.companySection}>
      <div
        ref={companyRef}
        className={`${styles.company} ${
          isVisible ? styles.animate : styles.initialPosition
        }`}
        style={companyStyles}
        onClick={openModal}
      >
        <div className={`${styles.companyTitle}`}>{title}</div>

        <CustomModal
          isOpen={isModalOpen}
          onClose={closeModal}
          imageUrl={imageUrl}
          title={title}
          description={description}
          siteUrl={siteUrl}
          imagePosition={imagePosition}
          logo={logo}
        />
      </div>
    </div>
  );
};

export default Companies;
